var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.679,977.862a14.5,14.5,0,1,1,14.5,14.5A14.511,14.511,0,0,1,8.679,977.862Zm1.487,0a13.013,13.013,0,1,0,13.013-13.013A13,13,0,0,0,10.166,977.862Zm3.346,0a.864.864,0,0,1,.209-.511l5.949-6.32a.744.744,0,0,1,1.08,1.023l-4.775,5.066H32.1a.744.744,0,0,1,0,1.487H15.975l4.775,5.066a.786.786,0,0,1-.023,1.057.752.752,0,0,1-1.057-.035l-5.949-6.32a.661.661,0,0,1-.209-.511Z",
    transform: "translate(-8.679 -963.362)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow_back.fcbeef189646aaff349c738eef1cb318.svg";
export { ForwardRef as ReactComponent };